/** @module csi/widget/_svg/Unlock */
define([
	"dijit/form/Button",
	"csi/_base/underscore",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(Button, _, _Plugin, PluginFactory, util) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "lock_open",
		pluginName: "unlock",
		title: "CanvasUnlockShape",

		/**
		 * Enable if there is at least one shape is selected and that is locked
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this.inherited(arguments) && shapes && shapes.length >= 1 && this.isAnyShapeLocked(shapes);
		},

		/**
		 * Return true if atleast one shape is locked from shapes list
		 * @param  {_Shape[]} shapes
		 */
		isAnyShapeLocked: function(shapes) {
			return _.some(shapes, function(shape) { return util.isShapeLocked(shape); });
		},

		onClick: function() {
			this.editor.lockShapes(false);
		}
	});
});